export var MatchmakingState = /*#__PURE__*/ function(MatchmakingState) {
    MatchmakingState[MatchmakingState["MatchmakingUpdate"] = 1] = "MatchmakingUpdate";
    MatchmakingState[MatchmakingState["MatchmakingError"] = 2] = "MatchmakingError";
    MatchmakingState[MatchmakingState["MatchmakingReconnect"] = 5] = "MatchmakingReconnect";
    return MatchmakingState;
}({});
